/*
 * The User Organisation components english translation.
 */
export const USER_ORGANISATION_COMPONENT_EN = {
  orgaManagement: 'Organisation Management',
  manageOrgaUsersAndSettings: 'Manage organization users and settings',
  loadingOrgaData: 'Loading organization data…',
  retry: 'Retry',
  orgaDetails: 'Organisation Details',
  createUser: 'Create User',
  manageBilling: 'Manage subscription',
  cancelSubscription: 'Cancel Subscription',
  userManagement: 'User Management',
  currentUser: 'Current User',
  noUsersFoundInThisOrga: 'No users found in this organisation.',
  OrganizationName: 'Organisation Name',
  Product: 'Product',
  Active: 'Active',
  CustomerID: 'Customer ID',
  organisationId: 'Organisation ID',
  seats: 'Seats',
  tier: 'Tier',
  used: 'Used',
  available: 'Available',
  freeTrialEnd: 'Free trial ends',
  toViewThisPage: 'To view this page you need to be a Premium Customer',
  subscriptionStatus: 'Subscription Status',
  accountType: 'Account Type',
  contractEndDate: 'Contract End Date',
  salesContact: 'Sales Contact',
  supportContact: 'Support Contact',
  enterpriseDetails: 'Enterprise Details',
  seatsOverview: 'Seat Overview',
  assignTier: 'Assign Tier',
  selectTierPlaceholder: 'Select a tier',
  tierOptionUseOrgDefault: 'Use organisation default tier',
  tierHelpOrgDefault:
    'If you keep organisation default, this user automatically follows your organisation tier.',
  tierHelpExplicit:
    'If you pick a specific tier, this user is pinned to that tier and uses one seat there.',
  effectiveTierLabel: 'Effective tier after save',
  effectiveTierUsesOrgDefault: 'This user will inherit the organisation default tier.',
  effectiveTierUsesExplicit: 'This user will use this explicit per-user tier override.',
  tierNotSet: 'No tier set',
  noContract: 'No contract information available',
  contactSupport: 'Contact Support',
  userManagementIntro:
    'Manage teammates here. Use Edit to update profile details, tier assignment, or password reset.',
  userManagementEmptyTitle: 'No managed users yet',
  userManagementEmptyDescription:
    'Create your first teammate to start collaboration across your organisation workspace.',
  cancel: 'Cancel',
  createUserDescription: 'Add a new teammate to your organisation.',
  fullNamePlaceholder: 'Full name',
  emailPlaceholder: 'Email address',
  assignedTierLabel: 'Assigned tier',
  additionalLicenseWarning:
    'There are no free seats for this tier. Creating this user will purchase an additional license.',
  userCreatedSuccessfully: 'User created successfully',
  pleaseTypeInAName: 'Please type in a name.',
  pleaseTypeInAnEmail: 'Please type in an email.',
  nameMustBeAtLeastTwoCharacters: 'Name must be at least 2 characters.',
  nameMustNotBeLongerThanThirtyCharacters: 'Name must not be longer than 30 characters.',
  stepPurchasing: 'Purchasing license…',
  stepSyncing: 'Activating license…',
  stepSyncingHint: 'This may take a few seconds.',
  stepCreating: 'Creating user…',
  createUserPaid: 'Create user (paid)',
  deleteUser: 'Delete user',
  deleteUserConfirmTitle: 'Are you sure you want to delete this user?',
  deleteUserConfirmDescription:
    'This will permanently delete {name} and transfer their resources to an organisation admin. This action cannot be undone.',
  userDeletedSuccessfully: 'User deleted successfully',
  deleteUserFailed: 'Failed to delete user'
}
/*
 * The User Organisation components german translation.
 */
export const USER_ORGANISATION_COMPONENT_DE = {
  orgaManagement: 'Organisationsmanagement',
  manageOrgaUsersAndSettings: 'Verwalte Nutzer und Einstellungen deiner Organisation',
  loadingOrgaData: 'Organisationsdaten werden geladen…',
  retry: 'Wiederholen',
  orgaDetails: 'Organisationsdetails',
  createUser: 'Nutzer erstellen',
  manageBilling: 'Abo verwalten',
  cancelSubscription: 'Abonnement kündigen',
  userManagement: 'Nutzerverwaltung',
  currentUser: 'Aktueller Nutzer',
  noUsersFoundInThisOrga: 'Keine Nutzer in dieser Organisation gefunden.',
  OrganizationName: 'Organisationsname',
  Product: 'Produkt',
  Active: 'Aktiv',
  CustomerID: 'Kunden-ID',
  organisationId: 'Organisations-ID',
  seats: 'Nutzer',
  tier: 'Tarif',
  used: 'Genutzt',
  available: 'Verfügbar',
  freeTrialEnd: 'Kostenloser Testzeitraum endet',
  toViewThisPage: 'Um diese Seite zu sehen, benötigst du einen Premium-Account',
  subscriptionStatus: 'Abonnementstatus',
  accountType: 'Kontotyp',
  contractEndDate: 'Vertragsende',
  salesContact: 'Vertriebskontakt',
  supportContact: 'Supportkontakt',
  enterpriseDetails: 'Enterprise-Details',
  seatsOverview: 'Sitzplatzübersicht',
  assignTier: 'Tarif zuweisen',
  selectTierPlaceholder: 'Tarif auswählen',
  tierOptionUseOrgDefault: 'Standardtarif der Organisation verwenden',
  tierHelpOrgDefault:
    'Wenn du den Organisationsstandard nutzt, folgt dieser Nutzer automatisch dem Organisationstarif.',
  tierHelpExplicit:
    'Wenn du einen konkreten Tarif auswählst, bleibt dieser Nutzer auf diesem Tarif und belegt dort einen Sitz.',
  effectiveTierLabel: 'Effektiver Tarif nach dem Speichern',
  effectiveTierUsesOrgDefault: 'Dieser Nutzer übernimmt den Standardtarif der Organisation.',
  effectiveTierUsesExplicit: 'Dieser Nutzer verwendet diese explizite Tarifzuweisung.',
  tierNotSet: 'Kein Tarif gesetzt',
  noContract: 'Keine Vertragsinformationen verfügbar',
  contactSupport: 'Support kontaktieren',
  userManagementIntro:
    'Hier verwaltest du dein Team. Mit Bearbeiten passt du Profil, Tarifzuweisung und Passwort-Reset an.',
  userManagementEmptyTitle: 'Noch keine verwalteten Nutzer',
  userManagementEmptyDescription:
    'Erstelle das erste Teammitglied, um die Zusammenarbeit in deiner Organisation zu starten.',
  cancel: 'Abbrechen',
  createUserDescription: 'Füge ein neues Teammitglied zu deiner Organisation hinzu.',
  fullNamePlaceholder: 'Vollständiger Name',
  emailPlaceholder: 'E-Mail-Adresse',
  assignedTierLabel: 'Zugewiesener Tarif',
  additionalLicenseWarning:
    'Für diesen Tarif sind keine freien Plätze vorhanden. Das Erstellen dieses Nutzers kauft eine zusätzliche Lizenz.',
  userCreatedSuccessfully: 'Nutzer erfolgreich erstellt',
  pleaseTypeInAName: 'Bitte gib einen Namen ein.',
  pleaseTypeInAnEmail: 'Bitte gib eine E-Mail-Adresse ein.',
  nameMustBeAtLeastTwoCharacters: 'Der Name muss mindestens 2 Zeichen lang sein.',
  nameMustNotBeLongerThanThirtyCharacters: 'Der Name darf nicht länger als 30 Zeichen sein.',
  stepPurchasing: 'Lizenz wird gekauft…',
  stepSyncing: 'Lizenz wird aktiviert…',
  stepSyncingHint: 'Dies kann einige Sekunden dauern.',
  stepCreating: 'Nutzer wird erstellt…',
  createUserPaid: 'Kostenpflichtig Nutzer erstellen',
  deleteUser: 'Nutzer löschen',
  deleteUserConfirmTitle: 'Möchtest du diesen Nutzer wirklich löschen?',
  deleteUserConfirmDescription:
    '{name} wird dauerhaft gelöscht und alle Ressourcen werden an einen Organisationsadmin übertragen. Diese Aktion kann nicht rückgängig gemacht werden.',
  userDeletedSuccessfully: 'Nutzer erfolgreich gelöscht',
  deleteUserFailed: 'Nutzer konnte nicht gelöscht werden'
}
